import { useState } from "react";
import { Mail, Phone, Send, CheckCircle, AlertCircle } from "lucide-react";
import { apiurl } from "../config/config";
import axios from "axios";
import Layout, { Container } from "../components/layout";

export default function ApplicationInvite() {
  const [method, setMethod] = useState("email");
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!value) {
      setMessage({ type: "error", text: "Please enter a valid value" });
      return;
    }

    try {
      setLoading(true);
      setMessage(null);

      const payload = {
        contactType: method,
        contactValue: value,
        sendType: "APPLICATION_FORM_LINK",
      };

      const res = await axios.post(apiurl + "/send-application-link", payload);

      setMessage({ type: "success", text: res.data.message });
      setValue("");
    } catch (err) {
      setMessage({
        type: "error",
        text: err.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    // <Layout>
    //   <Container overflow="overflow-scroll">
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600 p-6">
          <div className="w-full max-w-md bg-white/90 backdrop-blur-xl rounded-2xl shadow-2xl p-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              Send Application Form
            </h2>
            <p className="text-sm text-gray-500 mb-6">
              Send application form link via Email or WhatsApp
            </p>

            {/* Method Selector */}
            <div className="flex gap-3 mb-5">
              <button
                type="button"
                onClick={() => setMethod("email")}
                className={`flex-1 flex items-center justify-center gap-2 px-4 py-2 rounded-xl border transition ${
                  method === "email"
                    ? "bg-indigo-600 text-white border-indigo-600"
                    : "border-gray-300 text-gray-600"
                }`}
              >
                <Mail size={18} /> Email
              </button>

              <button
                type="button"
                onClick={() => setMethod("whatsapp")}
                className={`flex-1 flex items-center justify-center gap-2 px-4 py-2 rounded-xl border transition ${
                  method === "whatsapp"
                    ? "bg-green-600 text-white border-green-600"
                    : "border-gray-300 text-gray-600"
                }`}
              >
                <Phone size={18} /> WhatsApp
              </button>
            </div>

            {/* Input */}
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type={method === "email" ? "email" : "tel"}
                placeholder={
                  method === "email"
                    ? "Enter email address"
                    : "Enter WhatsApp number"
                }
                value={value}
                onChange={(e) => setValue(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              />

              <button
                type="submit"
                disabled={loading}
                className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-3 rounded-xl font-semibold hover:opacity-90 transition"
              >
                {loading ? (
                  "Sending..."
                ) : (
                  <>
                    <Send size={18} /> Send Link
                  </>
                )}
              </button>
            </form>

            {/* Message */}
            {message && (
              <div
                className={`mt-4 flex items-center gap-2 p-3 rounded-xl text-sm ${
                  message.type === "success"
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {message.type === "success" ? (
                  <CheckCircle size={18} />
                ) : (
                  <AlertCircle size={18} />
                )}
                {message.text}
              </div>
            )}
          </div>
        </div>
    //   </Container>
    // </Layout>
  );
}